/**
 * The guest hero's visual, "Game cluster": 7 game icons piled into an overlapping cluster (like a
 * game-logo collage), different sizes and tilts, each floating gently on its own beat, over a soft
 * glow with a few sparkles. The biggest, front icon is the first game (Hot first) and carries the
 * Hot tag.
 */
import type { HeroGame } from './types';
import { HeroFrame, HeroIcon } from './heroArt';
import './cluster.css';

/** Slots in paint order (back to front is set in CSS); slot 1 is the big centre icon. */
const SLOTS = 7;

export interface GameClusterProps {
  /** 6–12 games, already ordered (pickHeroGames); the cluster shows the first SLOTS. */
  games: HeroGame[];
  /**
   * True when the player prefers reduced motion or turned animations off in Sound & motion:
   * render the same frame with nothing moving (no keyframes, no timers).
   */
  still: boolean;
}

export function GameCluster({ games, still }: GameClusterProps) {
  const shown = games.slice(0, SLOTS);
  return (
    <HeroFrame games={shown} still={still}>
      <div className="gh-cluster">
        <div className="gh-cluster__box">
          <div className="gh-glow gh-cluster__glow" />
          {shown.map((game, i) => (
            <div key={`${game.id}-${i}`} className={`gh-cluster__slot gh-cluster__slot--${i + 1}`}>
              <div className="gh-cluster__float">
                <HeroIcon game={game} showHot={i === 0} className="gh-cluster__icon" />
              </div>
            </div>
          ))}
          <span className="gh-sparkle gh-cluster__sparkle--1" />
          <span className="gh-sparkle gh-cluster__sparkle--2" />
          <span className="gh-sparkle gh-cluster__sparkle--3" />
        </div>
      </div>
    </HeroFrame>
  );
}
